import React from 'react';
import PropTypes from 'prop-types';
import { CollapsibleLineItems } from '../CollapsibleLineItems/index';
import convertToCurrency from '../../helpers/convertToCurrency';
import InfoIcon from '../../assets/img/kplus-info.svg';
import flagIcon from '../../assets/img/kplus-flag.png';

export function OwnershipTimeline({ cashPrice, purchase90, fullTerm, termMonths, defaultOpen }) {
  return (
    <CollapsibleLineItems
      icon={<img src={flagIcon} alt="" className="k-collapsible-card__icon-img" />}
      title="Choose when to become the owner"
      subtitle="Purchase your merchandise at anytime"
      defaultOpen={defaultOpen}
      className="k-collapsible-card--owner"
    >
      <div className="k-ownership-timeline">
        <div className="k-ownership-timeline__track">
          <div className="k-ownership-timeline__point k-ownership-timeline__point--cash">
            <div className="k-ownership-timeline__label">
              Cash
              <br />
              Price
            </div>
            <div className="k-ownership-timeline__dot" />
            <div className="k-ownership-timeline__value">{convertToCurrency(cashPrice)}</div>
          </div>
          <div className="k-ownership-timeline__point k-ownership-timeline__point--90">
            <div className="k-ownership-timeline__label">
              Within
              <br />3 months
            </div>
            <div className="k-ownership-timeline__dot" />
            <div className="k-ownership-timeline__value">{convertToCurrency(purchase90)}</div>
          </div>
          <div className="k-ownership-timeline__midline" aria-hidden="true">
            Anytime
            <br />
            in between
          </div>
          <div className="k-ownership-timeline__point k-ownership-timeline__point--full">
            <div className="k-ownership-timeline__label">
              Full term
              <br />
              {termMonths} month
            </div>
            <div className="k-ownership-timeline__dot" />
            <div className="k-ownership-timeline__value">{convertToCurrency(fullTerm)}</div>
          </div>
        </div>
        <div className="k-ownership-timeline__info">
          <img src={InfoIcon} alt="" className="k-ownership-timeline__info-icon" />
          <p>
            Your purchase amount changes over time. The earlier you purchase, the more you can save. Your exact purchase
            amount will be shown in your lease agreement.
          </p>
        </div>
      </div>
    </CollapsibleLineItems>
  );
}

OwnershipTimeline.propTypes = {
  cashPrice: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  purchase90: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fullTerm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  termMonths: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  defaultOpen: PropTypes.bool,
};

OwnershipTimeline.defaultProps = {
  cashPrice: undefined,
  purchase90: undefined,
  fullTerm: undefined,
  termMonths: undefined,
  defaultOpen: true,
};
